export default [
    {
      path: '/guides',
      name: 'guides-read',
      component: () => import('@/views/guides/guide-list/GuideList.vue'),
      meta: {
        resource: 'Guides',
        action: 'read',
      },
    },
    {
      path: '/guides/create',
      name: 'guides-create',
      component: () => import('@/views/guides/guide-list/GuideForm.vue'),
      meta: {
        resource: 'Guides',
        action: 'create',
      },
    },
    {
      path: '/guides-category',
      name: 'guide-category-read',
      component: () => import('@/views/guides/category-list/CategoryList.vue'),
      meta: {
        resource: 'Guide Categories',
        action: 'read',
      },
    },
    {
      path: '/guides-category/create',
      name: 'guide-category-create',
      component: () => import('@/views/guides/category-list/CategoryForm.vue'),
      meta: {
        resource: 'Guide Categories',
        action: 'create',
      },
    }
]